import { render, staticRenderFns } from "./MyButtonIsVisible.vue?vue&type=template&id=638fc799&scoped=true&"
import script from "./MyButtonIsVisible.vue?vue&type=script&lang=js&"
export * from "./MyButtonIsVisible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638fc799",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638fc799')) {
      api.createRecord('638fc799', component.options)
    } else {
      api.reload('638fc799', component.options)
    }
    module.hot.accept("./MyButtonIsVisible.vue?vue&type=template&id=638fc799&scoped=true&", function () {
      api.rerender('638fc799', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyButtonIsVisible.vue"
export default component.exports